import { SavableRateTableSchema } from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-builder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCheckoutExperiencesForAbTestBuilder = {
  name: "getCheckoutExperiencesForAbTestBuilder" as const,
  input: z.null(),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string(),
      active: z.boolean(),
      rateTables: z.array(SavableRateTableSchema),
    }),
  ),
};
export type GetCheckoutExperiencesForAbTestBuilderOutput = z.infer<
  typeof getCheckoutExperiencesForAbTestBuilder.output
>;
